import { initialState } from '..'
import type { UserInfoCommon, DashboardUser } from '../../../schema/user'
import {
  SET_INFO,
  UPDATE_DEFAULT_LOGO,
  DELETE_DEFAULT_LOGO,
} from '../../actions/user/user'

import type { UserActions } from '../../actions/user/user'

export type UserInfoOutgoing = Partial<UserInfoCommon & {
  consentForMarketingContact: boolean,
  consentedForPhoneCalls: boolean,
  consentedForJobExpiryEmail: boolean,
}>

const reducer = (
  state: DashboardUser | undefined,
  action: UserActions,
): DashboardUser => {
  if (!state) return initialState.user

  if (action.type === SET_INFO) {
    return {
      ...state,
      ...action.payload,
      isInitialized: true,
    }
  }

  if (action.type === UPDATE_DEFAULT_LOGO) {
    return {
      ...state,
      company: {
        ...state.company,
        defaultLogo: {
          key: action.payload,
        },
      },
    }
  }

  if (action.type === DELETE_DEFAULT_LOGO) {
    return {
      ...state,
      company: {
        ...state.company,
        defaultLogo: {
          key: '',
        },
      },
    }
  }

  return state
}

export default reducer
